import { render, staticRenderFns } from "./FormulateStatusSelector.vue?vue&type=template&id=68c167ad&"
import script from "./FormulateStatusSelector.js?vue&type=script&lang=js&"
export * from "./FormulateStatusSelector.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/mijnmooiestraat.vlaanderen/develop.mijnmooiestraat.vlaanderen/pro-develop.mijnmooiestraat.vlaanderen/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68c167ad')) {
      api.createRecord('68c167ad', component.options)
    } else {
      api.reload('68c167ad', component.options)
    }
    module.hot.accept("./FormulateStatusSelector.vue?vue&type=template&id=68c167ad&", function () {
      api.rerender('68c167ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/Formulate/FormulateStatusSelector/FormulateStatusSelector.vue"
export default component.exports